import { Injectable } from '@angular/core';
import { PricingRepository } from './pricing.repository';
import { Observable } from 'rxjs';
import { generalTransaccionResponse } from 'src/app/shared/domain/shared.request';
import { PRI_ActivarDesactivarTarifaRequest, PRI_ListarTarifaPorTipoServicioRequest, PRI_MantenimientoTarifaRequest, PRI_ObtenerProfitMinimoRequest, getDetailZonaRutaRequest, getTarifasEspecialesRequest, listarauditoriaRequest, managementTarifaEspecialRequest } from '../tarifario-sli/domain/tarifario-sli.request';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PricingService extends PricingRepository {

  constructor(
    private readonly http: HttpClient
  ) { super() }

  //#region TARIFARIO SLI

  // override setTariff(): Observable<generalTransaccionResponse> {
  //   return null
  // }

  override PRI_ListarTarifaPorTipoServicio(request: PRI_ListarTarifaPorTipoServicioRequest): Observable<any> {
    return this.http.post<any>(`${environment.PATH_API}/supply/getTariffByServiceType`, request)

  }

  override PRI_ObtenerProfitMinimo(request: PRI_ObtenerProfitMinimoRequest): Observable<any> {
    return this.http.post<any>(`${environment.PATH_API}/supply/getProfitMinimoByServicio`, request)
  }

  override PRI_MantenimientoTarifa(request: PRI_MantenimientoTarifaRequest): Observable<any> {
    return this.http.post<any>(`${environment.PATH_API}/supply/setTarifa`, request)
  }

  override PRI_ActivarDesactivarTarifa(request: PRI_ActivarDesactivarTarifaRequest): Observable<any> {
    return this.http.post<any>(`${environment.PATH_API}/supply/disabledTarifa`, request)
  }

  override managementTarifaEspecial(request: managementTarifaEspecialRequest): Observable<generalTransaccionResponse> {
    return this.http.post<generalTransaccionResponse>(`${environment.PATH_API}/supply/managementTarifaEspecial`, request)
  }

  override getTarifasEspeciales(request: getTarifasEspecialesRequest): Observable<any> {
    return this.http.post<any>(`${environment.PATH_API}/supply/getTarifasEspecialesSLI`, request)
  }
  //#endregion

  override getDetailZonaRuta(request: getDetailZonaRutaRequest): Observable<any> {
    return this.http.post<any>(`${environment.PATH_API}/logistic/getDetailZonaRuta`, request)
  }

  override listarauditoria(request: listarauditoriaRequest): Observable<any>{

       return this.http.post<any>(`${environment.PATH_API}/supply/listartablasauditoria`, request)
  }
  

}
